module.exports = __webpack_public_path__ + "static/media/danger-info.289ccc3c.svg";